import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { useGetBreakingNews } from '@/application/services/settings.service'
import { resolveLanguage } from '@/application/i18n/language'
import { investigationSlug } from '@/application/seo/investigation-url'

/** Editorial breaking-news flag. Renders nothing unless an admin has turned
 * it on and given it a message or a linked investigation. */
export function HomeBreakingBar() {
  const { t, i18n } = useTranslation()
  const lang = resolveLanguage(i18n.language)
  const { data: breaking } = useGetBreakingNews(lang)

  if (!breaking?.active || !breaking.message) return null

  const content = (
    <>
      <span className="font-bold uppercase tracking-wide">{t('home.breaking_label')}</span>
      <span>{breaking.message}</span>
    </>
  )

  return (
    <div className="w-full bg-primary text-primary-foreground px-4 py-2 text-sm flex items-center gap-3">
      {breaking.investigationId ? (
        <Link
          to="/investigations/$slug"
          params={{
            // Falls back to the UUID (redirected by the detail route) when no slug is known.
            slug: investigationSlug(
              {
                id: breaking.investigationId,
                slugs: breaking.investigationSlugs,
                sourceLocale: undefined,
              },
              lang,
            ),
          }}
          className="flex items-center gap-3 no-underline hover:no-underline"
        >
          {content}
        </Link>
      ) : breaking.link ? (
        <a
          href={breaking.link}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-3 no-underline hover:no-underline"
        >
          {content}
        </a>
      ) : (
        <div className="flex items-center gap-3">{content}</div>
      )}
    </div>
  )
}
